export default __webpack_public_path__ + "static/media/015.4f8fa3e1.jpg";